import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { catchError, map, of } from 'rxjs';
import { ObjectMappingService } from '../../services/object-mapping.service';

/** Ohne Antwort heisst die Krume „Testelement“, nie wie die Routen-ID. */
const LABEL_WITHOUT_NAME = 'header.breadcrumb.objectMappingDetail';

export const objectMappingNameBreadcrumbResolver: ResolveFn<string> = (route) => {
  const projectId = route.pathFromRoot.map((r) => r.paramMap.get('projectId')).find(Boolean) ?? '';
  const mappingId = route.paramMap.get('mappingId') ?? '';
  return inject(ObjectMappingService)
    .getDetail(projectId, mappingId)
    .pipe(
      map((mapping) => mapping.name || LABEL_WITHOUT_NAME),
      catchError(() => of(LABEL_WITHOUT_NAME)),
    );
};
